import { get } from 'lodash';
import { HOURS_FOR_INACTIVITY, OPERATOR_HOURS_FOR_INACTIVITY, IDLESTATUS_WARNING } from './constants';
import { PASS_OPERATOR } from '../../utilities/roles';
import { displayAutoLogoutWarning } from '../../actions/login';

const hoursToMilliseconds = (hours) => {
  return hours * 60 * 60 * 1000;
};

export const idleStatusDelay = (idleStatus) => (dispatch, getState) => {
  const state = getState();
  const roles = get(state, 'login.user.roles', null);

  if (idleStatus === IDLESTATUS_WARNING) {
    if (roles && roles.length) {
      const poCount = roles.filter((r) => r.role_type === PASS_OPERATOR).length;

      if (poCount && poCount === roles.length) {
        return hoursToMilliseconds(OPERATOR_HOURS_FOR_INACTIVITY);
      }
    }

    return hoursToMilliseconds(HOURS_FOR_INACTIVITY);
  }

  return undefined;
};

export const idleStatusAction = (idleStatus) => (dispatch) => {
  if (idleStatus === IDLESTATUS_WARNING) {
    dispatch(displayAutoLogoutWarning());
  }
};
